export * from "./LandingHead";
